export const GET_EVENT_TOKEN_COMPONENTS_REQUESTED =
  "GET_EVENT_TOKEN_COMPONENTS_REQUESTED";
export const GET_EVENT_TOKEN_COMPONENTS_FULFILLED =
  "GET_EVENT_TOKEN_COMPONENTS_FULFILLED";
export const GET_EVENT_TOKEN_COMPONENTS_REJECTED =
  "GET_EVENT_TOKEN_COMPONENTS_REJECTED";
